"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// adapted from map-obj (MIT), with modifications to pass the "whole object"
// from an array of objects into itself
var isObject = function isObject(value) {
  return typeof value === 'object' && value !== null;
};
// Customized for this use-case
var isObjectCustom = function isObjectCustom(value) {
  return isObject(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date) && !(globalThis.Blob && value instanceof globalThis.Blob);
};
function map(object, mapper) {
  var isSeen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new WeakSet();
  if (isSeen.has(object)) {
    return;
  }
  isSeen.add(object);
  var mapArray = function mapArray(array) {
    return array.forEach(function (element) {
      mapper(element);
      if (isObject(element)) {
        map(element, mapper, isSeen);
      }
    });
  };
  if (Array.isArray(object)) {
    mapArray(object);
  }
  for (var _i = 0, _Object$values = Object.values(object); _i < _Object$values.length; _i++) {
    var value = _Object$values[_i];
    mapper(value);
    if (isObjectCustom(value)) {
      Array.isArray(value) ? mapArray(value) : map(value, mapper, isSeen);
    }
  }
}
exports.default = map;